import * as types from './actionTypes';

const initialState = {
  claimDropdownData: [],
  approvalDetailData: [],
  approvalsList: [],
  punchDetailsList:[],
  extraDutyPaymentClaimList: [],
  approvalList:[],
  cancelList:[],
  manualPunchList: [],
  loading: false,
  error: null,
  success: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_CLAIM_DROPDOWN_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.FETCH_CLAIM_DROPDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        claimDropdownData: action.payload.data,
        success: false,
      };

    case types.FETCH_CLAIM_DROPDOWN_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.SAVE_EXTRA_DUTY_CLAIM_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    case types.SAVE_EXTRA_DUTY_CLAIM_SUCCESS:
      return { ...state, loading: false, success: true };

    case types.SAVE_EXTRA_DUTY_CLAIM_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };

     // Approval
    case types.SAVE_EXTRA_DUTY_APPROVAL_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    case types.SAVE_EXTRA_DUTY_APPROVAL_SUCCESS:
      return { ...state, loading: false, success: true };

    case types.SAVE_EXTRA_DUTY_APPROVAL_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };

    // Approval Detail List
    case types.FETCH_EXTRA_DUTY_APPROVAL_DETAIL_LIST_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.FETCH_EXTRA_DUTY_APPROVAL_DETAIL_LIST_SUCCESS:
      return { ...state, loading: false, approvalDetailData: action.payload.data, success: false };

    case types.FETCH_EXTRA_DUTY_APPROVAL_DETAIL_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload , success: false};

    // Approvals (List)
    case types.FETCH_EXTRA_DUTY_APPROVALS_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_EXTRA_DUTY_APPROVALS_SUCCESS:
      return { ...state, loading: false, approvalsList: action.payload.data };

    case types.FETCH_EXTRA_DUTY_APPROVALS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_PUNCH_DETAILS_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_PUNCH_DETAILS_SUCCESS:
      return { ...state, loading: false, punchDetailsList: action.payload.data };

    case types.FETCH_PUNCH_DETAILS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Cancel
    case types.SAVE_EXTRA_DUTY_CANCEL_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    case types.SAVE_EXTRA_DUTY_CANCEL_SUCCESS:
      return { ...state, loading: false, success: true };

    case types.SAVE_EXTRA_DUTY_CANCEL_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };

    // Cancel Detail List
    case types.FETCH_EXTRA_DUTY_CANCEL_DETAIL_LIST_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.FETCH_EXTRA_DUTY_CANCEL_DETAIL_LIST_SUCCESS:
      return { ...state, loading: false, approvalDetailData: action.payload.data, success: false };

    case types.FETCH_EXTRA_DUTY_CANCEL_DETAIL_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.FETCH_EXTRA_DUTY_CANCELS_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.FETCH_EXTRA_DUTY_CANCELS_SUCCESS:
      return { ...state, loading: false, approvalsList: action.payload.data, success: false };

    case types.FETCH_EXTRA_DUTY_CANCELS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_LIST_REQUEST:
      return { ...state, loading: true, error: null , success: false};
    case types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_LIST_SUCCESS:
      return { ...state, loading: false, extraDutyPaymentClaimList: action.payload.data, success: false };
    case types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.CONVERT_PAYMENT_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.CONVERT_PAYMENT_SUCCESS:
      return { ...state, loading: false, success: true };
    case types.CONVERT_PAYMENT_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

      // Approval List
    case types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_APPROVAL_LIST_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_APPROVAL_LIST_SUCCESS:
      return { ...state, loading: false, approvalList: action.payload.data, success: false };
    case types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_APPROVAL_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    // Cancel List
    case types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_CANCEL_LIST_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_CANCEL_LIST_SUCCESS:
      return { ...state, loading: false, cancelList: action.payload.data, success: false };
    case types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_CANCEL_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    // Cancel Payment
    case types.CANCEL_PAYMENT_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.CANCEL_PAYMENT_SUCCESS:
      return { ...state, loading: false, success: true };
    case types.CANCEL_PAYMENT_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    // ✅ Fetch Manual Punch List
    case types.FETCH_MANUAL_PUNCH_LIST_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.FETCH_MANUAL_PUNCH_LIST_SUCCESS:
      return { ...state, loading: false, manualPunchList: action.payload.data, success: false };
    case types.FETCH_MANUAL_PUNCH_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    // ✅ Save Manual Punch
    case types.SAVE_MANUAL_PUNCH_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.SAVE_MANUAL_PUNCH_SUCCESS:
      return { ...state, loading: false, success: true };
    case types.SAVE_MANUAL_PUNCH_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    // ✅ Delete Manual Punch
    case types.DELETE_MANUAL_PUNCH_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.DELETE_MANUAL_PUNCH_SUCCESS:
      return { ...state, loading: false, success: true };
    case types.DELETE_MANUAL_PUNCH_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    default:
      return state;
  }
}
